import Appointment from "./Appointment/Route";
import OfficeAppointment from "./OfficeAppointment/Route";
import Backup from "./Backup/Route";
import Cadre from "./Cadre/Route";
import CompanyCadre from "./CompanyCadre/Route";
import Company from "./Company/Route";
import EventType from "./EventType/Route";
import Office from "./Office/Route";
import Rank from "./Rank/Route";
import Regiment from "./Regiment/Route";
import Setting from "./Setting";
import Trade from "./Trade/Route";
import User from "./User/Route";
import RemoteUser from "./RemoteUser";
import UserStatus from "./UserStatus/Route";
import Units from "./Unit/Route";
import Area from "./Area/Route";
import Allowance from "./Allowance/Route";
import Organizations from "./Organizations/Route";
import Division from "./Division/Route";
import District from "./District/Route";
import Upazila from "./Upazila/Route";
import PostOffice from "./PostOffice/Route";
import Housing from "./Housing";
// import Flat from "./Flat/Route";
// import UserFlat from "./UserFlat/Route";
import SheetRoll from "./SheetRoll/Route";
import CompanyCamp from "./CompanyCamp/Route";
import DrivingLicense from "./DrivingLicense/Route";

export default [
    ...Appointment,
    ...OfficeAppointment,
    ...Backup,
    ...Cadre,
    ...CompanyCadre,
    ...Company,
    ...EventType,
    ...Office,
    ...Rank,
    ...Regiment,
    ...Setting,
    ...Trade,
    ...User,
    ...RemoteUser,
    ...UserStatus,
    ...Units,
    ...Area,
    ...Allowance,
    ...Organizations,
    ...Division,
    ...District,
    ...Upazila,
    ...PostOffice,
    // ...Building,
    // ...Flat,
    ...SheetRoll,
    ...CompanyCamp,
    ...Housing,
    ...DrivingLicense,
];
